import React from "react";
import { Container, Row, Col, Card, Image, Button } from "react-bootstrap";
import bimetallicImg from "../Assets/Images/bimetallic-product.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const Bimetallicproductsandwashers = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Bimetallic Products & Washers | Delta Engineering</title>
        <meta
          name="description"
          content="High-performance bimetallic washers and products engineered for conductivity, corrosion resistance, and secure connections between dissimilar metals in electrical and mechanical systems."
        />
        <meta
          name="keywords"
          content="Bimetallic Washers, Bimetallic Products, Copper Aluminum Washer, Explosion Bonded Products, Friction Welded Bimetallic Components, Electrical Panel Washers, Power Distribution Washers, Renewable Energy Connectors"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Bimetallic Products & Washers" />
        <meta
          property="og:description"
          content="Engineered with copper-aluminum bonding, our bimetallic products and washers minimize galvanic corrosion while ensuring reliable conductivity. Applications in switchgear, EVs, transformers, and renewable energy systems."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/bimetallic-products-washers"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/bimetallic-products-washers.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bimetallic Products & Washers" />
        <meta
          name="twitter:description"
          content="Bimetallic products & washers combining copper and aluminum for enhanced conductivity, durability, and corrosion resistance. Custom shapes, plating, and sizes available."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/bimetallic-products-washers.jpg"
        />
      </Helmet>
      
      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
               <span className="blue-text">Bimetallic Products</span>{" "}
            <span className="white-text"> & Washers</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
              Engineered for conductivity and corrosion resistance, bimetallic washers ensure secure connections in electrical and mechanical systems.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5 bg-light pt-3" style={{ position: "relative" }}>
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold section-title">
                Bimetallic Products and Washers
                <span className="title-underline"></span>
              </h3>
            </Col>
          </Row>
          <Row className="mb-5 align-items-center">
            <Col md={4} className="text-center mb-3 mb-md-0">
              <Image
                src={bimetallicImg}
                alt="Bimetallic Product"
                fluid
                rounded
              />
            </Col>
            <Col md={8}>
              <p
                className="text-muted"
                style={{ lineHeight: "1.8", textAlign: "justify" }}
              >
                Our bimetallic products and washers are crafted to meet the
                critical needs of both conductivity and mechanical stability in
                various industrial applications. Using advanced bonding
                techniques like friction welding and explosion bonding, we
                combine metals such as copper and aluminum. This enhances
                performance while minimizing galvanic corrosion and electrical
                resistance.
              </p>
              <p
                className="text-muted"
                style={{ lineHeight: "1.8", textAlign: "justify" }}
              >
                The result is a reliable, long-lasting solution suited for
                systems requiring the joining of dissimilar metals. These
                products are ideal for use in electrical panels, power
                distribution units, renewable energy systems, and automotive
                applications. Our team also offers tailored shapes, sizes, and
                plating options to meet client-specific requirements.
              </p>
            </Col>
          </Row>

          <section className="py-5 ">
            <Container>
              <Row className="mb-4">
                <Col md={{ span: 8, offset: 2 }}>
                  <h4 className="fw-bold text-decoration-underline mb-3">
                    Applications
                  </h4>
                  <ul
                    className="text-muted"
                    style={{
                      lineHeight: "1.8",
                      listStyleType: "disc",
                      paddingLeft: "1.2rem",
                    }}
                  >
                    <li>Switchgear and Control Panel Assemblies</li>
                    <li>Battery Terminals for Automotive & Energy Storage</li>
                    <li>Transformer and Generator Connections</li>
                    <li>Hybrid and Electric Vehicle Components</li>
                    <li>Solar & Wind Energy Distribution Panels</li>
                    <li>Railway & Marine Power Junctions</li>
                    <li>High Voltage Substations</li>
                  </ul>
                </Col>
              </Row>
            </Container>
          </section>
        </Container>
      </section>
    </>
  );
};

export default Bimetallicproductsandwashers;
